import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import type { DashboardStats } from "../lib/types";

const STAT_LABELS: Array<[Exclude<keyof DashboardStats, "recentlyModified">, string]> = [
  ["totalEmployees", "Total Employees"],
  ["activeCards", "Active Cards"],
  ["inactiveCards", "Inactive Cards"],
  ["applePassesGenerated", "Apple Wallet Passes"],
  ["googlePassesGenerated", "Google Wallet Passes"],
  ["samsungPassesGenerated", "Samsung Wallet Passes"],
];

export default function Dashboard() {
  const [stats, setStats] = useState<DashboardStats | null>(null);

  useEffect(() => {
    api<DashboardStats>("/dashboard").then(setStats).catch(() => setStats(null));
  }, []);

  return (
    <div>
      <div className="topbar">
        <div>
          <h1 className="page-title">Dashboard</h1>
          <div className="page-subtitle">Overview of business cards and Wallet distribution</div>
        </div>
        <Link to="/employees/new" className="btn btn-gold">
          + Create New Business Card
        </Link>
      </div>

      <div className="stat-grid">
        {STAT_LABELS.map(([key, label]) => (
          <div className="stat-tile" key={key}>
            <div className="value">{stats ? stats[key] : "—"}</div>
            <div className="label">{label}</div>
          </div>
        ))}
      </div>

      <div className="card">
        <h3 style={{ marginTop: 0 }}>Recently Modified</h3>
        {!stats || stats.recentlyModified.length === 0 ? (
          <div className="empty-state">No employees yet.</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
                <th>Status</th>
                <th>Updated</th>
              </tr>
            </thead>
            <tbody>
              {stats.recentlyModified.map((e) => (
                <tr key={e.id}>
                  <td>
                    <Link to={`/employees/${e.id}`}>{e.displayName}</Link>
                  </td>
                  <td>{e.jobTitle}</td>
                  <td>
                    <span className={`badge badge-${e.status.toLowerCase()}`}>{e.status}</span>
                  </td>
                  <td>{new Date(e.updatedAt).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
